import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import React, {useState} from "react";

const ContactForm = ({ title }) => {
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    subject: "КАСКО",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const onClick = async () => {
    const payload = {
      subject: inputs.subject,
      email: inputs.email,
      text: inputs.message,
      contact_email: "info@citybrokers.com.ua",
      phone: inputs.phone,
      name: inputs.name,
    };

    try {
      const response = await fetch(
        "https://citybrokers.com.ua/app/api/v1/mailer/send",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      alert("Запит успішно відправлено");
      setInputs({
        name: "",
        email: "",
        phone: "",
        message: "",
        subject: "КАСКО",
      });
    } catch (error) {
      console.error("Помилка надсилання запиту", error);
      alert(
        "Сталася помилка при відправці запиту. Будь ласка, спробуйте ще раз пізніше."
      );
    }
  };

  const theme = createMuiTheme({
    overrides: {
      MuiFormControlLabel: {
        label: {
          fontFamily: "'Hind', sans-serif",
          fontSize: '1.2rem',
          color: '#000', 
        },
      },
      MuiFormLabel: {
        root: {
          fontFamily: "'Hind', sans-serif",
          fontSize: '1.6rem',
          color: '#000', 
          '&$focused': {
            color: '#000', 
          },
        },
        focused: {}, 
      },
      MuiRadio: {
        root: {
          '& svg': {
            fontSize: 20,
          },
          '&$checked': {
            color: '#d42e22', 
          },
        },
        checked: {},  
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
    <form
      name="contact-form"
      className="contact-me"
      id="contact-form"
      action="php/contact.php"
      method="POST"
    >
      <div className="messages"></div>
      <Box display="flex" flexDirection="column" alignItems="flex-start" style={{ marginBottom: '32px' }}>
        <FormControl >
          <FormLabel id="radio-buttons-group-label" style={{ marginBottom: '20px' }}>Виберіть вид страхування</FormLabel>
          <RadioGroup 
            aria-labelledby="radio-buttons-group-label"
            name="subject"
            value={inputs.subject}
            onChange={handleInputChange}
          >
            <FormControlLabel value="КАСКО" control={<Radio color="default"/>} label="КАСКО" />
            <FormControlLabel value="Майно" control={<Radio color="default"/>} label="Майно" />
            <FormControlLabel value="Життя, здоров'я" control={<Radio color="default"/>} label="Життя, здоров'я" />
            <FormControlLabel value="Інше" control={<Radio color="default"/>} label="Інше" />
          </RadioGroup>
        </FormControl>
      </Box>
      <div className="form-group">
        <label className="sr-only" htmlFor="name">
          Ваше ім’я
        </label>
        <input
          type="text"
          name="name"
          className="form-control"
          id="name"
          required="required"
          placeholder="Ім’я"
          data-error="Це поле обов’язкове"
          value={inputs.name}
          onChange={handleInputChange}
        />
        <div className="help-block with-errors mt-20"></div>
      </div>
      <div className="form-group">
        <label className="sr-only" htmlFor="phone">
           Ваш телефон
        </label>
        <input
          type="phone"
          name="phone"
          className="form-control"
          id="phone"
          placeholder="Телефон"
          required="required"
          data-error="Будь ласка, введіть коректний номер телефону"
          value={inputs.phone}
          onChange={handleInputChange}
        />
        <div className="help-block with-errors mt-20"></div>
      </div>
      <div className="form-group">
        <label className="sr-only" htmlFor="email">
           Ваш Email
        </label>
        <input
          type="email"
          name="email"
          className="form-control"
          id="email"
          placeholder="Email"
          required="required"
          data-error="Будь ласка, введіть коректний Email"
          value={inputs.email}
          onChange={handleInputChange}
        />
        <div className="help-block with-errors mt-20"></div>
      </div>
      <div className="form-group">
        <label className="sr-only" htmlFor="message">
          Коментар
        </label>
        <textarea
          name="message"
          className="form-control"
          id="message"
          rows="2"
          placeholder="Коментар"
          data-error="Будь ласка, залиште коментар"
          value={inputs.message}
          onChange={handleInputChange}
        ></textarea>
        <div className="help-block with-errors mt-20"></div>
      </div>
      <div className="text-center">
        <button
          type="button"
          name="submit"
          className="btn btn-color btn-circle"
          onClick={onClick}
        >
          Відправити
        </button>
      </div>
    </form>
    </ThemeProvider>
  );
};

export default ContactForm;
